export const environment = {
  production: true,
  baseUrl: 'https://fe.assuraprotect.com',
  openBankingUrl: 'https://ob.assuraprotect.com',
  imageBase: 'https://fe.assuraprotect.com/components/',
  logEvents: false,
  name: 'prod'
};
